import { render, staticRenderFns } from "./contactUs.vue?vue&type=template&id=5d253a64&scoped=true"
import script from "./contactUs.vue?vue&type=script&setup=true&lang=js"
export * from "./contactUs.vue?vue&type=script&setup=true&lang=js"
import style0 from "./contactUs.vue?vue&type=style&index=0&id=5d253a64&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d253a64",
  null
  
)

export default component.exports